import { SplashScreen } from "../interface";
import { removeSplashScreen } from "../shared/splashScreen";

export const splashScreen: SplashScreen = {
    hide: () => {
        removeSplashScreen();
    },
};
